"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (x) {
	var d = new Date();
	d.setMonth(d.getMonth() - x);
	return Math.floor(d.getTime() / 1000);
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/date/getLastXMonthEpoch.js
// module id = 62
// module chunks = 0